import React from 'react';
import { Link } from 'react-router-dom';
import { TourPopupLink } from '../components/TourPopupLink';
import { CATALOG, Song } from '../data/songs';
function SongLine({
  song
}: {
  song: Song;
}) {
  return <span className="lowercase" data-id="element-241" data-mp="14m2j2aacuobd">{`${song.title} (${song.duration})`}</span>;
}
export function Music() {
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-242" data-mp="19eduoaegjyjr">
      {/* Header — matches the home page exactly */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-243" data-mp="1ncu1008ern1d">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-244" data-mp="1scq5e0l0pghg">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-245" data-mp="3p501qv7sr00s">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-246" data-mp="3p6jlwwwkpv7u">
            catalog
          </Link>
          <TourPopupLink data-id="element-247" data-mp="3u5ebqisykk1g" />
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-248" data-mp="1nt33z1vk2pvv">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-249" data-mp="1j1cpqkthzhz6">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-250" data-mp="1e3t8rd5f0r3j">
          contact
        </a>
      </header>

      {/* Catalog: years -> releases -> songs */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-251" data-mp="26q47sjddijy8">
        {CATALOG.map((group, yearIdx) => <div key={group.year} className={`flex w-full flex-col items-start ${yearIdx > 0 ? 'mt-8' : ''}`} data-id="element-252" data-mp="21q9niyo3ssm5" data-mpi={yearIdx}>
            {/* Year label */}
            <p className="mb-2 font-bold lowercase" data-id="element-253" data-mp="1sr4jxdxoq934">{group.year}</p>

            {/* Releases within this year */}
            {group.releases.map((release, releaseIdx) => <div key={`${group.year}-${releaseIdx}`} className={`flex flex-col items-start gap-1 ${releaseIdx > 0 ? 'mt-4' : ''}`} data-id="element-254" data-mp="hbfyir02xi4f" data-mpi={releaseIdx}>
                {/* Release name (only if it's a named EP / B side) */}
                {release.name && <p className="font-bold lowercase" data-id="element-255" data-mp="8w9w71ldzyls">{release.name}</p>}

                {/* Tracks */}
                {release.songs.map(song => <SongLine key={song.id} song={song} data-id="element-256" data-mp="36qjfgzgq1p" />)}
              </div>)}
          </div>)}
      </section>

      {/* Footer Padding */}
      <div className="h-24" data-id="element-257" data-mp="4vzs5uh5ni9k" />
    </main>;
}